module.exports = __webpack_public_path__ + "static/media/offline.9c4b860f.png";